import { endPoints, getDocEditorServiceEndPoint, getUserServiceEndPoint } from "./base-url/api-constants";
import { apiService } from "./base-api-service/base-api-service";
import { readCookie } from "../Util/helper";

class DocEditorService {
  DocEditorService(url: any) {
    return getDocEditorServiceEndPoint(url);
  }
  TrackEvent(data: any) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const apiEndpoint = this.DocEditorService(`${endPoints.docEditorService.TRACK_EVENT}`);

    return apiService.post(apiEndpoint, data, headers);
  }
}

export default new DocEditorService();
